import { z } from 'zod'
import {
  nullSafeOptionalFirestoreTimestamp,
  nullSafeOptionalString,
} from '../shared/schema'

export const schema = z.object({
  stripeProductId: nullSafeOptionalString(),
  sectionPassPrice: z.coerce
    .number()
    .or(z.string())
    .transform((val) => {
      if (typeof val === 'string') {
        return parseInt(val, 10)
      } else {
        return val
      }
    })
    .refine((val) => !isNaN(val) && Number.isInteger(val), {
      message: 'sectionPassPrice must be a valid integer',
    }),
  updatedAt: nullSafeOptionalFirestoreTimestamp(),
})

export const empty = Object.freeze(
  schema.parse({
    stripeProductId: '',
    sectionPassPrice: 0,
    updatedAt: null,
  })
)

export interface FirestoreSettingsSectionPassPricing extends z.infer<
  typeof schema
> {}
